import React from 'react'
import cn from 'classnames'
import t from './testgen.module.scss'

export const TYPE_LABEL = { single: 'один или несколько', ordering: 'последовательность', matching: 'пары' }
export const TYPE_TITLE = { single: 'Один или несколько', ordering: 'Последовательность', matching: 'Пары' }
export const TYPE_ORDER = ['single', 'ordering', 'matching']

const Check = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" aria-hidden="true">
    <path d="M5 12l5 5L20 7" />
  </svg>
)

// Тело вопроса с правильным ответом: варианты / порядок / пары (форматы QuizDraft.questions).
export const QuestionBody = ({ q }) => {
  if (q.type === 'single')
    return (
      <div className={t.answers}>
        {(q.options || []).map((o, i) => (
          <span key={i} className={cn(t.ans, { [t.ansOk]: o.correct })} style={{ display: 'flex', gap: 8 }}>
            <span style={{ flex: 1 }}>{o.text}</span>
            {o.correct && (
              <span role="img" aria-label="верный ответ">
                <Check />
              </span>
            )}
          </span>
        ))}
      </div>
    )
  if (q.type === 'ordering')
    return (
      <div className={t.order}>
        {(q.items || []).map((item, i) => (
          <span key={i} className={t.ans}>
            {i + 1}. {item}
          </span>
        ))}
      </div>
    )
  return (
    <div className={t.pairs}>
      {(q.pairs || []).map((p, i) => (
        <React.Fragment key={i}>
          <span className={t.ans}>{p.left}</span>
          <span className={t.ans}>{p.right}</span>
        </React.Fragment>
      ))}
    </div>
  )
}

// Полоса распределения типов вопросов + легенда.
export const TypeBar = ({ counts }) => {
  const types = TYPE_ORDER.filter((k) => counts?.[k] > 0)
  if (!types.length) return null
  return (
    <div>
      <div className={t.typebar} aria-hidden="true">
        {types.map((k) => (
          <span key={k} className={t[`t_${k}`]} style={{ flex: counts[k] }} />
        ))}
      </div>
      <div className={t.legend}>
        {types.map((k) => (
          <span key={k}>
            <i className={t[`t_${k}`]} />
            {TYPE_TITLE[k]} · {counts[k]}
          </span>
        ))}
      </div>
    </div>
  )
}
